module.exports = __webpack_public_path__ + "static/media/anali1000x.e2976dfa.png";